import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-wall-block',
  templateUrl: './skeleton-wall-block.component.html',
  styleUrls: ['./skeleton-wall-block.component.scss']
})
export class SkeletonWallBlockComponent {}
